/* No se recomienda guardar tokens JWT (JSON Web Tokens) en el localStorage del navegador,
 * ya que el localStorage no está diseñado para almacenar información sensible.
 * Si un atacante logra acceder al localStorage, podría acceder al token y hacerse pasar por el usuario autenticado,
 * lo que podría permitirles acceder a funciones y recursos protegidos por autenticación.

 * En su lugar, se recomienda almacenar el token JWT en una cookie HTTPOnly y segura (HTTPOnly y Secure).
 * Una cookie segura solo se enviará a través de una conexión HTTPS, lo que garantiza que la cookie no se pueda interceptar en tránsito.
 * Además, una cookie HTTPOnly no se puede acceder desde JavaScript, lo que proporciona una capa adicional de seguridad contra ataques XSS.
 */ 

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Establece la cookie con la duración y el token JWT
const setCookie = (name, value, days) => {
    cookies.set(name, value, { path: '/', expires: new Date(Date.now() + days * 86400000), secure: true, sameSite: 'lax' });
}
  
// Lee la cookie con el token JWT
const getCookie = (name) => {
    return cookies.get(name);
};
  
// Borra la cookie con el token JWT
const deleteCookie = (name) => {
    cookies.remove(name, { path: '/' });
};

export {setCookie, getCookie, deleteCookie}
  